export const GlobalEvents = {
  RELOAD_PREVIEW: 'RELOAD_PREVIEW',
  PROMPT_NEW_NAME: 'PROMPT_NEW_NAME',
  PROMPT_LOGIN_FOR_SAVE: 'PROMPT_LOGIN_FOR_SAVE',
  INSERT_COMPONENT_DIALOG_OPEN: 'INSERT_COMPONENT_DIALOG_OPEN',
  INSERT_SCRIPT_SNIPPET_DIALOG_OPEN: 'INSERT_SCRIPT_SNIPPET_DIALOG_OPEN',
  UI_THEME_CHANGE: 'UI_THEME_CHANGE'
};
